

















































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {DevisElementsList} from '@/models';

import storeDevisElementsList from '@/stores/modules/devisElementsList';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

import storeDevis from "@/stores/modules/devis"
import storeTva from "@/stores/modules/tva"

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
	}
})
export default class CrudDevisElementsListEdit extends AbstractEditVue<DevisElementsList> {

	private step: number = 1;
	private storeDevis = storeDevis;
	private storeTva = storeTva;
	private saveDisabled = true;
	private items = ['Produits', 'Services'];

	public constructor() {
		super(
			storeDevisElementsList,
			'Element modifié',
			'Element créé',
		);
	}

	public checkInput() {
		this.saveDisabled = !(this.item.tva && this.item.type && this.item.amount && this.item.quantity);
	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeDevis.dispatch('getAll');
		await storeTva.dispatch('getAll');
		await super.mounted();
		this.checkInput();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		if (this.$route.name === 'devisElementsList-edit') {
			this.$route.meta.title = 'Modification  d\'un élément';
		}
	}

}
